import * as math from 'mathjs';
import { Fraction } from 'mathjs';

function improperFractionToMixedNumber(n: any, d: any) {
    const i = Math.floor(Number(n) / Number(d));
    n = Number(n) - i * Number(d);
    return { i, n, d };
}

// Amount could be fraction
function formatAmount(amount: any, multiplier: any) {
    if (!amount) return null;
    const fraction = math.multiply(math.fraction(amount), multiplier) as unknown as Fraction;

    // Check if it's a whole number by checking if denominator is 1
    if ((fraction as any).d === 1 || !(fraction as any).d) {
        // Resolves to an integer
        return math.number(fraction);
    }
    // It's decimal
    let formattedAmount = '';
    const mixedNumber = improperFractionToMixedNumber((fraction as any).n, (fraction as any).d);

    if (mixedNumber.i) {
        formattedAmount = `${mixedNumber.i} `;
    }
    if (mixedNumber.n && mixedNumber.d) {
        formattedAmount += `${mixedNumber.n}/${mixedNumber.d}`;
    }
    return formattedAmount;
}

export function parseAmount(amount: any) {
    if (!amount) return null;
    if (Number.isNaN(Number(amount))) {
        const match = /^(\d+ )?(\d+)\/(\d+)$/.exec(amount);
        if (!match) return null;
        const [, i, n, d] = match;
        return math.add(Number(i) || 0, math.fraction(Number(n), Number(d)));
    }
    return math.fraction(Number(amount));
}

export default function formatIngredient(ingredient: any, multiplier: any, nameFirst = false) {
    const ingredientParts = [];
    if (nameFirst) {
        ingredientParts.push(ingredient.name);
        ingredientParts.push('-');
    }
    if (ingredient.amount) {
        ingredientParts.push(formatAmount(ingredient.amount, multiplier));
    }
    if (ingredient.unit) {
        ingredientParts.push(ingredient.unit);
    }
    if (!nameFirst) {
        ingredientParts.push(ingredient.name);
    }

    return ingredientParts.join(' ');
}
